<div class="background-blue">
  <div class="account-page-banner container">
    <h1 style="font-size: 22.5px"><adp-label labelKey="Account_Title"></adp-label></h1>
  </div>
</div>

<div class="container account-page">
  <div class="d-block d-lg-none" *ngIf="isMobile">
    <div class="mobile-nav-select">
      <mat-select
        *ngIf="navLinks && isNavLinksLoaded"
        [(value)]="selectedMobileTab"
        (selectionChange)="mobileTab($event)"
        disableOptionCentering>
        <mat-select-trigger>
          <div class="d-flex align-items-center menu-selected">
            <mat-icon class="selected-icon" [svgIcon]="selectedMobileTab.icon"></mat-icon>
            <div class="menu-selected-text" [innerHtml]="getLabelValue(selectedMobileTab.label)"></div>
            <mat-icon class="arrow-down-right" [svgIcon]="'chevron-down'"></mat-icon>
          </div>
        </mat-select-trigger>
        <mat-option *ngFor="let link of navLinks | pghOrderBy: order : ascending" [value]="link" [gtmClick]="getLabelValue(link.label)"
                    [gtmLinkURL]="link.link">
          <div class="d-flex align-items-center menu-option-items">
            <mat-icon [svgIcon]="link.icon"></mat-icon>
            <adp-label [labelKey]="link.label"></adp-label>
          </div>
        </mat-option>
      </mat-select>
    </div>
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>

  <div class="row d-none d-lg-block" *ngIf="!isMobile">
    <div class="col-12 d-inline-flex">
      <nav mat-tab-nav-bar class="menu-border mr-20" *ngIf="isNavLinksLoaded">
        <a
          mat-tab-link
          *ngFor="let link of navLinks | pghOrderBy: order : ascending"
          [routerLink]="link.link"
          [active]="rla.isActive"
          [ngClass]="rla.isActive ? 'menu-active theme-primary-menu-color' : ''"
          routerLinkActive
          #rla="routerLinkActive"
          [gtmClick]="getLabelValue(link.label)"
          [gtmLinkURL]="link.link">
          <mat-icon
            [svgIcon]="rla.isActive ? link.iconActive : link.icon"
            [ngClass]="rla.isActive ? 'theme-primary-icon-color' : ''"></mat-icon>
          <adp-label [labelKey]="link.label" [ngClass]="rla.isActive ? 'theme-primary-icon-color' : ''"></adp-label>
        </a>
      </nav>
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  </div>
</div>

<ng-template #template>
  <router-outlet> </router-outlet>
</ng-template>
